import React, { useContext, useEffect } from 'react';

import { TEACHER_ASSIGNMENT_V2_INSIGHTS_URL } from 'config/urls';

import { trackMixpanelPageView } from 'utils/integrations/mixpanel';

import Typography from 'components/Typography';
import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const EmptyDataState = ({ withoutStudentWorks }) => {
  const user = useContext(UserContext);

  useEffect(() => {
    trackMixpanelPageView(user.id, {
      feature: 'insights',
      view: 'empty-data-state',
      normalizedURL:
        process.env.REACT_APP_BASE_FRONTEND_URL +
        TEACHER_ASSIGNMENT_V2_INSIGHTS_URL
    });
  }, [user]);

  return (
    <div className={styles.loaderContainer}>
      <div className={styles.imageContainer}></div>
      <Typography variant="H-TEXT-1" className={styles.text}>
        {withoutStudentWorks
          ? 'No student works have been submitted yet'
          : 'Not able to get insights at the moment'}
      </Typography>
    </div>
  );
};

export default EmptyDataState;
